import React from "react"

export const SearchBox = () => {
    return <>
        <input type="search" placeholder="Hledaný text" aria-label="Search" className="form-control" />
        <button className="btn btn-primary btn-sm my-0 p" type="submit">
            <i className="fas fa-search"></i>
        </button>
    </>
}